import React from "react";

import { inIframe } from "Utils/partnerIframeCheck";

import { AppFooter } from "Common/AppFooter";
import IframeFooter from "Common/IframeFooter";

const Footer = (_props) => (inIframe() ? <IframeFooter /> : <AppFooter />);

export default Footer;
